<form *ngIf="searchForm" [formGroup]="searchForm" (focusout)="handleSearchOnBlur($event)" class="relative ">
	<div class="flex gap-4 mb-4 lg:flex-col">
		<app-radio-item [value]="true" class="w-full" [selectedBlackBorder]="true" formControlName="doesOperateOutsideOwnCountry" [text]=" 'onboarding.application.kyc.outside-eu.yes' | translate" />
		<app-radio-item [value]="false" class="w-full" [selectedBlackBorder]="true" formControlName="doesOperateOutsideOwnCountry" [text]="'onboarding.application.kyc.outside-eu.no' | translate" />
	</div>
	<app-input
		*ngIf="doesOperateOutsideOwnCountry.value" 
		class="w-screen max-w-full pt-4 sm:max-w-sm"
		name="search"
		formControlName="search"
		[placeholder]="'country-selector.search.placeholder' | translate"
		[prefixIcon]="'search.svg'"
		[prefixIconId]="'search'"
		[autocomplete]="'off'"
		(handleOnFocus)="handleSearchOnFocus()"
		data-testid="input-bank-search"></app-input>

	<div class="absolute left-0 z-50 w-full h-56 px-4 -mt-3 bg-white border shadow-lg rounded-2xl border-black-6" *ngIf="isSearchActive" id="country-list" (mousedown)="$event.preventDefault()">
		<div class="h-full overflow-auto">
			<ng-container *ngFor="let country of filteredCountries">
				<app-checkbox [formControl]="selectedCountries.get(country.code)" type="list">
					<div text class="flex items-center justify-between">
						<span class="font-medium">{{ country.name }}</span>
						<div class="flex justify-center w-8">
							<img
								class="max-w-[32px] max-h-[24px] object-contain rounded-[4px] border border-solid border-black-6"
								[src]="'https://flagcdn.com/' + country.code.toLowerCase() + '.svg'" />
						</div>
					</div>
				</app-checkbox>
			</ng-container>
		</div>
		<div
			class="pointer-events-none absolute bottom-0 left-0 w-full h-[48px] rounded-2xl"
			style="background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%)"></div>
	</div>
</form>
<div class="-mt-3">
	<app-inline-alert *ngIf="searchForm.errors?.requireCountryIfOutsideMarket && searchForm.touched" type="error" [message]="'country-selector.no-country-selected' | translate"></app-inline-alert>
	<ng-container *ngFor="let country of getCheckedCountries()">
		<div class="flex items-center justify-between h-12 py-3 border-b border-black-6">
			<div class="flex items-center gap-4">
				<div class="flex justify-center w-8">
					<img
					class="max-w-[32px] max-h-[24px] object-contain rounded-[4px] border border-solid border-black-6"
					[src]="'https://flagcdn.com/' + country.code.toLowerCase() + '.svg'" />
				</div>
				<span class="font-medium">{{ country.name }}</span>
			</div>
			<button (click)="removeCountry(country.code)">
				<app-svg-icon class="text-medium-grey" width="20" height="20" [iconName]="'close.svg'" [iconId]="'close'"></app-svg-icon>
			</button>
		</div>
	</ng-container>
</div>
